import { environmentService } from '@core/services/Environment.service';

const msalConfig = {
  auth: {
    clientId: environmentService.azureApplicationClientId,
    authority: `https://login.microsoftonline.com/${environmentService.azureDirectoryTenantId}`,
    redirectUri: `${window.location.origin}/auth-blank.html`
  }
} as const;

export { msalConfig };
